import React, { useState } from 'react';
import { CiImageOff } from 'react-icons/ci'; /** SPDX-License-Identifier: MPL-2.0
  Copyright 2022 Klarr-Agency
 */
import Modal from '@common/modal';

const ContectInfoButtonModal = () => {
  const [isShow, setIsShow] = useState(false);
  const showModal = () => setIsShow(true);
  const hideModal = () => setIsShow(false);

  return (
    <>
      <button className="common" onClick={showModal}>
        Contect
      </button>
      {isShow && (
        <Modal
          title="QR코드로 연락처 추가하기"
          closeProps={{ onClick: hideModal }}
        >
          <CiImageOff size={64} color="lightgray" />
          <span>
            개인정보 보호를 위해 QR코드 미제공 중입니다.
            <br />
            포트폴리오 완성 후에 표시할 예정입니다.
          </span>
        </Modal>
      )}
    </>
  );
};

export default ContectInfoButtonModal;
